// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './QuickNotesIndicator.scss';

const QuickNotesIndicator = ({ count, hide }) => {
    if (hide || !count) return null;

    return <div className="QuickNotesIndicator" />;
};

QuickNotesIndicator.propTypes = {
    count: PropTypes.number,
    hide: PropTypes.bool,
};

export default QuickNotesIndicator;
